module.exports = __webpack_public_path__ + "img/wechat.586397f1.png";